var _path, _path2, _path3, _circle, _circle2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTaxDocument(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.5 42.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M34.5 27.1V10.7C34.5 7.6 32 5 28.9 5H13.7C10.5 5 8 7.6 8 10.7V37"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_main",
    d: "M8 37.1l4.4-4.2 4.4 4.2 4.5-4.2 4.4 4.2 4.4-4.2 4.4 4.2"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "IC_4L_sub",
    d: "M16.5 21.3l9.6-9.5"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_sub",
    cx: 16.7,
    cy: 12.1,
    r: 0.7
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "IC_4L_dot",
    cx: 25.8,
    cy: 21.3,
    r: 2.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTaxDocument);
export default __webpack_public_path__ + "static/media/taxDocument.35f1ac3e04bdf05281c6340b6bf7a336.svg";
export { ForwardRef as ReactComponent };